import httpClient from './httpClient'

const END_POINT = '/api/horarios'

const getAllHorarios = () => httpClient.get(END_POINT)

export {

    getAllHorarios

}